import gql from 'graphql-tag';

export default (
  email,
  allowResearch,
  timestamp,
  agreedToTerms = true,
  notShownAgreement = false,
  language = 'en',
) => gql`
    mutation CreateUser {
      createUser (
        email: "${email}"
        language: "${language}"
        agreement: {
          agreedToMobileTerms: ${agreedToTerms}
          notShownAgreement: ${notShownAgreement}
          allowResearch: ${allowResearch}
          dateAgreedToMobileTerms: "${timestamp}"
        }
      ) {
        id
        email
        language
        agreement {
          agreedToMobileTerms
          notShownAgreement
          allowResearch
          dateAgreedToMobileTerms
        }
      }
    }
  `;
